<template>
  <div v-if="items.length > 1" :class="['x-tabs', customClass]">
    <div v-for="(item, idx) in items" :key="item.id || idx">
      <a
        :class="['x-tabs-item', { active: currentIndex === idx }]"
        @click="handleTabClick(idx, item)"
      >
        {{ item.title }}
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface TabItem {
  id?: string | number;
  title: string;
  [key: string]: any;
}

interface Props {
  items: TabItem[];
  modelValue?: number;
  customClass?: string;
}

interface Emits {
  (e: 'update:modelValue', value: number): void;
  (e: 'tab-click', index: number, item: TabItem): void;
}

const props = withDefaults(defineProps<Props>(), {
  items: () => [],
  modelValue: 0,
  customClass: '',
});

const emit = defineEmits<Emits>();

const currentIndex = computed({
  get: () => props.modelValue,
  set: (value: number) => emit('update:modelValue', value),
});

const handleTabClick = (idx: number, item: TabItem) => {
  currentIndex.value = idx;
  emit('tab-click', idx, item);
};
</script>

<style lang="scss" scoped>
.x-tabs {
  height: 46px;
  background: #fff;
  border-radius: 999px;
  box-shadow: 0px 0px 20px 0px #00000014;
  display: flex;
  align-items: center;
  padding: 6px;
  gap: 8px;
  pointer-events: all;
  border: none;

  &-item {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0 20px;
    height: 32px;
    border-radius: 16px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: var(--text-1-60);
    background: transparent;
    transition:
      background 0.2s,
      color 0.2s;

    &:hover {
      color: var(--text-1);
    }

    &.active {
      background: var(--back-4);
      color: var(--text-1);
      box-shadow: none;
    }
  }
}
</style>
